(function () {
            const PERSONALMESSAGERULES_TEXT = 'Please keep your message kind and appropriate. Don\'t include inappropriate language or personal information about yourself or others. Your name and email address will be visible to the recipient.';
            const PERSONALMESSAGERULES_MARKER = 'data-ecw-injected-message';

            // Recursively search light DOM + all nested shadow roots for a selector
            function findDeep(root, selector) {
              if (!root || !root.querySelector) return null;
              const found = root.querySelector(selector);
              if (found) return found;
              const all = root.querySelectorAll('*');
              for (const el of all) {
                if (el.shadowRoot) {
                  const r = findDeep(el.shadowRoot, selector);
                  if (r) return r;
                }
              }
              return null;
            }

            function injectPersonalMessageNote(root) {
              const personalMessageEl = findDeep(root, '#personalMessage');
              if (!personalMessageEl) return false;

              const parent = personalMessageEl.parentElement;
              if (!parent) return false;

              // --- existing note injection (unchanged) ---
              if (!parent.nextElementSibling?.hasAttribute(PERSONALMESSAGERULES_MARKER)) {
                const note = document.createElement('p');
                note.setAttribute(PERSONALMESSAGERULES_MARKER, '');
                note.textContent = PERSONALMESSAGERULES_TEXT;
                parent.insertAdjacentElement('afterend', note);
              }

              // --- force line-break in personal message ---
              const LINEBREAK_MARKER = 'data-ecw-linebreak-style';
              const shadowRoot = personalMessageEl.getRootNode();

              if (shadowRoot instanceof ShadowRoot && !shadowRoot.querySelector(`style[${LINEBREAK_MARKER}]`)) {
                const style = document.createElement('style');
                style.setAttribute(LINEBREAK_MARKER, '');
                style.textContent = `
                  #personalMessage .tiptap.ProseMirror {
                    overflow-wrap: break-word !important;
                    word-wrap: break-word !important;
                  }

                  .mbtn,
                  button.formkit-input,
                  .text-input input,
                  .textarea-input,
                  input
                   {
                    border-radius: 0px !important;
                  }

                  .text-input, .label.upper_case:nth-child(2) {
                    margin-top: 25px !important;
                  }

                  .label.upper_case + .text-input {
                    margin-top: 16px !important;
                  }

                  .label.upper_case {
                    text-transform: revert !important;
                  }

                  [data-ecw-error-summary] {
                    color: #dc3545 !important;
                    font-size: 14px !important;
                    margin: 8px 0 !important;
                  }
                `;
                shadowRoot.appendChild(style);
              }

              return true;
            }

            const FORM_ERROR_SUMMARY_TEXT = 'There are errors in the form above.';
            const FORM_ERROR_SUMMARY_MARKER = 'data-ecw-error-summary';

            function syncFormErrorSummary(root) {
              const btnCol = findDeep(root, '.btn-col');
              if (!btnCol) return;

              const shadowRoot = btnCol.getRootNode();
              if (!(shadowRoot instanceof ShadowRoot)) return;

              const hasErrors = shadowRoot.querySelectorAll('.v-err').length > 0;
              const existing = btnCol.querySelector(`[${FORM_ERROR_SUMMARY_MARKER}]`);

              if (hasErrors && !existing) {
                const summary = document.createElement('p');
                summary.setAttribute(FORM_ERROR_SUMMARY_MARKER, '');
                summary.textContent = FORM_ERROR_SUMMARY_TEXT;
                btnCol.insertAdjacentElement('afterbegin', summary); // above the button; use 'beforeend' for below
              } else if (!hasErrors && existing) {
                existing.remove();
              }
            }

            // Poll briefly for the field to appear, since shadow root population can lag mutation events
            function pollForPersonalMessage(attempts) {
              if (typeof attempts !== 'number') attempts = 15;
              const done = injectPersonalMessageNote(document.body);
              if (!done && attempts > 0) {
                setTimeout(() => pollForPersonalMessage(attempts - 1), 300);
              }
            }

            function observe(root) {
              injectPersonalMessageNote(root);

              root.querySelectorAll('*').forEach((el) => {
                if (el.shadowRoot) observe(el.shadowRoot);
              });

              const observer = new MutationObserver((mutations) => {
                for (const m of mutations) {
                  m.addedNodes.forEach((n) => {
                    if (n.nodeType === 1) {
                      injectPersonalMessageNote(n);
                      if (n.shadowRoot) observe(n.shadowRoot);
                      n.querySelectorAll && n.querySelectorAll('*').forEach((el) => {
                        if (el.shadowRoot) observe(el.shadowRoot);
                      });
                    }
                  });
                }
                injectPersonalMessageNote(root);
                syncFormErrorSummary(root);
              });

              observer.observe(root, { childList: true, subtree: true, characterData: true });
            }

            document.addEventListener('DOMContentLoaded', () => observe(document.body));
            window.addEventListener('load', () => {
              setTimeout(() => observe(document.body), 500);
              pollForPersonalMessage();
            });
          })();

          function getEcwFormRef() {
            let formRef = document.querySelector('[action*="/cart/add"] input[value="product"]')?.closest('form');
            if (!formRef) {
              formRef = document.querySelector('form[action*="/cart/add"]');
            }
            return formRef;
          }

          function reloadEcwWidget() {
            const containerId = 'ecardwidget_id_precheckout';

            document.querySelectorAll('ecardwidget-precheckout, ecardwidget-modals-precheckout')
              .forEach(el => el.remove());

            document.getElementById(containerId)?.remove();

            const formRef = getEcwFormRef();
            if (!formRef) {
              console.error('[ECW reload] no form found — aborting');
              return;
            }

            const widgetHolster = document.createElement('div');
            widgetHolster.setAttribute('id', containerId);
            formRef.append(widgetHolster);

            window.widgetData = window.widgetData || {};
            window.widgetData[containerId] = {
              domain: 'https://app.ecardwidget.com',
              currentID: 'precheckout',
              appMode: 'precheckout',
              ewidgContainerID: containerId,
              widget: { id: 'precheckout', wconfig: { locale: 'en' } },
              css: '',
              locale: 'en',
              ecards: []
            };

            if (typeof window.ewLoadApp === 'function') {
              try {
                window.ewLoadApp();
              } catch (err) {
                console.error('[ECW reload] ewLoadApp threw:', err);
              }
            } else {
              console.error('[ECW reload] window.ewLoadApp not found');
            }

            // Widget rebuild is async — poll for the personal message field again
            if (typeof pollForPersonalMessage === 'function') {
              pollForPersonalMessage();
            }
          }

          window.addEventListener('unhandledrejection', e =>
            console.error('[ECW reload] unhandled rejection:', e.reason));

          window.addEventListener('load', function () {
            if (typeof window.jQuery === 'undefined') {
              console.error('jQuery not found on page load — ECW variant price sync will not run.');
              return;
            }

            $(window).on('cc-variant-updated', function (event, data) {
              const variant = data && data.variant;
              if (!variant) return;

              const price = (variant.price / 100).toFixed(2);

              const meta = document.querySelector('meta[property="og:price:amount"]');
              if (meta) meta.setAttribute('content', price);

              reloadEcwWidget();
            });
          });

          /// Intercept the scheduled date and turn it into a line item property
          (function () {
            const SCHEDULE_PROPERTY_NAME = 'Scheduled for';
            const SCHEDULE_INPUT_CLASS = 'ew-schedule-date';
            const TARGET_PATH = '/api/shopify/preCheckoutSend';

            function getEcwFormRef() {
              let formRef = document.querySelector('[action*="/cart/add"] input[value="product"]')?.closest('form');
              if (!formRef) {
                formRef = document.querySelector('form[action*="/cart/add"]');
              }
              return formRef;
            }

            function setScheduleValue(rawValue) {
              const formRef = getEcwFormRef();
              if (!formRef) {
                console.warn('[ECW schedule] no cart form found — cannot set schedule property');
                return;
              }
              let input = formRef.querySelector(`.${SCHEDULE_INPUT_CLASS}`);
              if (!input) {
                input = document.createElement('input');
                input.type = 'hidden';
                input.className = SCHEDULE_INPUT_CLASS;
                input.name = `properties[${SCHEDULE_PROPERTY_NAME}]`;
                formRef.prepend(input);
              }
              input.value = rawValue;
              console.log('[ECW schedule] captured sendAt →', rawValue);
            }

            function extractSendAt(body) {
              if (!body) return null;
              try {
                const parsed = typeof body === 'string' ? JSON.parse(body) : body;
                return parsed?.ecardData?.sendAt ?? parsed?.sendAt ?? null;
              } catch (e) {
                console.warn('[ECW schedule] could not parse XHR body', e);
                return null;
              }
            }

            const originalOpen = XMLHttpRequest.prototype.open;
            const originalSend = XMLHttpRequest.prototype.send;

            XMLHttpRequest.prototype.open = function (method, url, ...rest) {
              this.__ecwUrl = url;
              return originalOpen.call(this, method, url, ...rest);
            };

            XMLHttpRequest.prototype.send = function (body) {
              try {
                if (this.__ecwUrl && this.__ecwUrl.includes(TARGET_PATH)) {
                  const sendAt = extractSendAt(body);
                  if (sendAt) {
                    setScheduleValue(sendAt);
                  }
                }
              } catch (e) {
                console.warn('[ECW schedule] interceptor error', e);
              }
              return originalSend.call(this, body);
            };
          })();